<template>
  <div>
    <div v-if="propertyTypes">
      <boolean-property
        v-for="pt in propertyTypes"
        :key="pt.id"
        v-model="getUserProperty(pt.name).value"
        @input="(value) => change(getUserProperty(pt.name), value)"
        :prop-type="getUserPropertyType(pt.name)"
        component-class="mb-1 d-flex align-items-center flex-row-reverse justify-content-end"
        label-class="m-0 ml-2"
        control-class=""
      ></boolean-property>
    </div>
    <div v-else class="text-light small">
      loading...
    </div>
  </div>
</template>

<script>
import { cloneDeep, diffCollection, isAllowed } from '@/utils'
import BooleanProperty from '@/components/properties/BooleanProperty.vue'

export default {
  name: 'UserProperties',
  components: { BooleanProperty },
  props: {
    user: { type: Object },
  },

  data () {
    return {
      item: {},
      availableProperties: [
        'Email - weekly insights'
      ],
      propertyTypes: null,
      itemProperties: [],
    }
  },
  async mounted () {
    await this.reload()
  },
  methods: {
    async reload () {
      this.item = this.user
      const [
        propertyTypes
      ] = await Promise.all([
        this.$api.get('/user-property-types')
      ])
      this.propertyTypes = propertyTypes.data.filter(p => this.availableProperties.includes(p.name))

      // Fill with defaults
      // -> user property w/ a type w/o any other data (id, prop)
      this.itemProperties = this.item?.properties ?? []
      this.propertyTypes.forEach(property => {
        const userProp = this.getUserProperty(property.name)
        if (!userProp) {
          this.itemProperties.push({
            user_property_type_hash: property.id,
            type: property
          })
        } else {
          userProp.value = !!isAllowed(userProp.value)
        }
      })
    },
    getUserProperty (lookupValue) {
      if (!lookupValue || !this.itemProperties) return null
      return this.itemProperties.find(p => p.type && (p.type.name === lookupValue || p.type.id === lookupValue)) ?? null
    },
    getUserPropertyType (lookupValue) {
      if (!lookupValue || !this.propertyTypes) return null
      return this.propertyTypes.find(p => p.name === lookupValue || p.id === lookupValue) ?? null
    },
    async change (property) {
      if (typeof property.id === 'undefined') {
        this.$api.post(`/users/${this.item.id}/properties`, property, this.$root.client.client_hash)
      } else {
        this.$api.patch(`/users/${this.item.id}/properties/${property.id}`, property, this.$root.client.client_hash)
      }
    }
  }
}
</script>
